<!-- 考生信息管理 -->
<template>
  <div class="studentinfo">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入姓名/证件号码" style="width: 200px"
          @keyup.enter.native="tableLoad" @clear="
            query.query = '';
          tableLoad();
          " clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button size="small" style="margin:0px 10px;" @click="tableLoad">查询</el-button>
        </Debounce>
        <el-cascader v-model="cityIds" filterable clearable placeholder="请选择省市" :options="examineeList"
          :props="{ expandTrigger: 'hover' }" @change="handleChange"></el-cascader>
      </el-col>
      <el-button type="primary" size="small" @click="operatInfo(1)" v-if="$roleFilter('examinee:add')">添加</el-button>
      <input type="file" ref="uploadFile" @change="uploadFileChange" v-show="false">
      <el-dropdown @command="importFile" style="margin:0px 10px;">
        <el-button size="medium" type="primary">
          批量操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1" v-if="$roleFilter('examinee:download')">下载导入模板</el-dropdown-item>
          <el-dropdown-item command="2" v-if="$roleFilter('examinee:import')">导入考生信息</el-dropdown-item>
          <el-dropdown-item command="3" v-if="$roleFilter('examinee:import:photo')">导入考生照片</el-dropdown-item>
          <el-dropdown-item command="4">导出考生信息</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
      :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中"
      :height="$store.getters.getTableHeight">
      <el-table-column prop="photo" label="考生照片" width="80" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.photo" style="height:30px;" @click="viewPhoto(scope.row)">
        </template>
      </el-table-column>
      <el-table-column prop="name" width="120" label="姓名" align="center"></el-table-column>
      <el-table-column prop="surName" width="100" label="姓氏拼音" align="center"></el-table-column>
      <el-table-column prop="englishName" width="100" label="名字拼音" align="center"></el-table-column>
      <el-table-column width="60" label="性别" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sex === 1 ? "男" : "女" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="age" width="80" label="年龄" align="center"></el-table-column>
      <el-table-column prop="countryName" width="70" label="国籍" align="center"></el-table-column>
      <el-table-column prop="provinceName" width="70" label="省份" align="center"></el-table-column>
      <el-table-column prop="cityName" width="70" label="地市" align="center"></el-table-column>
      <el-table-column prop="birthDay" label="出生日期" width="130" align="center">
        <template slot-scope="scope">
          {{ $tagTime(scope.row.birthDay, "yyyy年MM月dd日") }}
        </template>
      </el-table-column>
      <el-table-column prop="idNumber" label="证件号码" width="200" align="center"></el-table-column>
      <el-table-column prop="mobile" label="联系电话" width="130" align="center"></el-table-column>
      <el-table-column prop="expressAddress" show-overflow-tooltip label="快递地址" align="center"></el-table-column>
      <el-table-column width="170" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" :disabled="scope.row.modify == 0" size="small" v-if="$roleFilter('studentinfo:update')"
            class="tableContentUpdateBut" @click="operatInfo(2, scope.row)">修改
          </el-button>
          <span style="margin:0px 5px" v-if="$roleFilter('studentinfo:update')">|</span>
          <el-button type="text" size="small" @click="operatInfo(3, scope.row)">密码初始化</el-button>
          <span style="margin:0px 5px"
            v-if="$roleFilter('studentinfo:update') && $roleFilter('studentinfo:delete')">|</span>
          <el-button type="text" size="small" v-if="$roleFilter('studentinfo:delete')" class="tableContentRemoveBut"
            @click="operatInfo(0, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog custom-class="dailogComponents" :title="title" :visible.sync="showAdd" :destroy-on-close="true"
      :close-on-click-modal="false" v-if="showAdd" :before-close="isDi" width="800px">
      <el-form :model="student" :rules="rules" ref="ruleForm" label-width="100px" style="padding:20px">
        <el-row style="margin-bottom: 20px;">
          <el-col :span="6">
            <el-upload class="avatar-uploader" action="api/upload" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="student.photo" :src="student.photo" class="avatar" />
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </el-upload>
          </el-col>
          <el-col :span="18">
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名：" prop="name">
                  <el-input v-model="student.name" placeholder="请输入姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别：" prop="sex">
                  <el-radio-group v-model="student.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓氏拼音：" prop="surName">
                  <el-input v-model="student.surName" placeholder="请输入姓氏拼音"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="名字拼音：" prop="englishName">
                  <el-input v-model="student.englishName" placeholder="请输入名字拼音"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="出生日期：" prop="birthDay">
                  <el-date-picker v-model="student.birthDay" type="date" value-format="yyyy-MM-dd"
                    format="yyyy 年 MM 月 dd 日" style="width:185px">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：" prop="mobile">
                  <el-input v-model="student.mobile" :disabled="!student.mobileShow" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="国籍：" prop="countryId">
              <el-select v-model="student.countryId" filterable placeholder="请选择国籍" style="width:100%">
                <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在省市：" prop="studentCity">
              <el-cascader v-model="student.studentCity" :options="examineeList" :props="{ expandTrigger: 'hover' }"
                style="width:100%"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件号码：" prop="idNumber">
              <el-input v-model="student.idNumber" :disabled="!student.idNumberShow" placeholder="请输入证件号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="快递地址：" prop="expressAddress">
              <el-input v-model="student.expressAddress" placeholder="请输入快递地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align:center">
          <el-col :span="24">
            <el-button type="primary" @click="submitStudentInfo" :loading="addStudentLoading">确 定</el-button>
            <el-button @click="calc()">取 消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog title="导入考生信息" :visible.sync="dialogVisible" width="20%" top="12%" :before-close="handleClose" center>
      <div v-if="listInfo && !succStatus" style="margin-bottom:20px">
        <p>导入文件中存在已注册考生数据{{ listInfo[0] }}条：</p>
        <p><span v-for="(item, index) in listInfo" :key="index"><span v-if="index != 0">{{ item }}<span
                v-if="index != listInfo.length - 1">、</span></span></span></p>
        <p>是否继续导入未注册的考生信息？</p>
      </div>
      <div v-else>
        成功导入考生数据{{ succNum.label }}条，失败{{ succNum.value }}条。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!succStatus" type="primary" @click="handleClose">取消</el-button>
        <el-button v-if="!succStatus" @click="sureImport">继续导入</el-button>
        <el-button v-else @click="handleClose">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="theTit" :visible.sync="dialogVisible1" width="20%" :before-close="handleClose1" center>
      <div style="margin-bottom: 10px;" v-if="theTit == '导入考生信息'">
        <p>不同考生的手机号码请尽量使用家长手机号码</p>
        <p>考生的初试密码是手机号后六位。</p>
      </div>
      <div style="margin-bottom: 10px;" v-else>
        <p>照片文件名以考生证件号码命名</p>
        <p>压缩包格式为zip，单个照片不超过2M，jpg/jpeg/png格式，压缩包里不要有文件夹。</p>
      </div>
      <span slot="footer">
        <div class="">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="toImport">上 传</el-button>
        </div>
      </span>
    </el-dialog>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"
      @pagination="tableLoad" />
  </div>
</template>

<script>
import { exportFile } from "@/uitls/globalFun.js";
import FileOperatDropdown from "@/views/admin/components/FileOperatDropdown";

export default {
  components: {
    FileOperatDropdown,
  },
  data () {
    return {
      type: null,
      showAdd: false,
      addStudentLoading: false,
      dialogVisible: false,
      dialogVisible1: false,
      tableList: [],
      tableIsLoad: true,
      examineeList: [], //省市联动
      visible: false,
      visibleObj: {
        sex: 1,
        cityIds: [],
        expressAddress: "", //地址
        birthDay: "",
      },
      cityIds: [],
      subCityIds: [],
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        provinceId: "", //省级
        cityId: "", //市id
      },
      permissionForm: {
        idNumber: {
          examSite: null,
          province: null,
          registerSite: null,
        },
        phone: {
          examSite: null,
          province: null,
          registerSite: null,
        },
        score: {
          examSite: null,
          province: null,
          registerSite: null,
        },
      },
      title: "添加考生",
      student: {
        birthDay: "",
        cityId: "",
        countryId: "",
        englishName: "",
        expressAddress: "",
        idNumber: "",
        mobile: "",
        name: "",
        photo: "",
        provinceId: "",
        sex: 1,
        surName: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请选择姓名", trigger: "change" }],
        surName: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请输入姓氏拼音"));
              }
              //小写字母+空格正则
              let nameTest = /^(?!_)([a-z]+)$/;
              if (!nameTest.test(value)) {
                return callback(new Error("姓氏拼音只允许输入小写字母！"));
              }
              callback();
            },
          },
        ],
        englishName: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请输入名字拼音"));
              }
              //小写字母+空格正则
              let nameTest = /^[a-z\s]*$/;
              if (!nameTest.test(value)) {
                return callback(new Error("名字拼音只允许输入小写字母！"));
              }
              callback();
            },
          },
        ],
        birthDay: [
          { required: true, message: "请选择出生日期", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        countryId: [
          { required: true, message: "请选择国籍", trigger: "change" },
        ],
        studentCity: [
          { required: true, message: "请选择所在省市", trigger: "change" },
        ],
        idNumber: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("请输入证件号码"));
              }
              //证件号码6-18位
              if (this.student.idNumberShow) {
                let idNumberTest = /^[a-zA-Z0-9]{6,18}$/;
                if (!idNumberTest.test(value)) {
                  return callback(new Error("请填写正确证件号码！"));
                }
              }
              callback();
            },
          },
        ],
        expressAddress: [
          { required: true, message: "请输入快递地址", trigger: "blur" },
        ],
      },
      countryList: [],
      saveAndUpdate: false,
      fileInfo: null,
      listInfo: null,
      succNum: {},
      succStatus: false,
      theTit: ''
    };
  },
  created () { },
  mounted () {
    this.getAllUser();
    this.tableLoad();
    this.getCountryList();
  },
  methods: {
    handleClose () {
      this.dialogVisible1 = false
      this.dialogVisible = false
    },
    handleClose1 () {
      this.dialogVisible1 = false
    },
    sureImport () {
      let formDate = new FormData();
      formDate.append("file", this.fileInfo);
      console.log(formDate);
      this.$axios.post('/examinee/import/0', formDate).then(res => {
        this.dialogVisible = true
        this.succNum = res.data.data
        this.succStatus = true
        this.tableLoad()
      })
    },
    calc () {
      this.showAdd = false;
      this.clearFrom();
    },
    isDi () {
      this.showAdd = false;
      this.clearFrom();
    },
    viewPhoto (info) {
      this.$alert(
        `<img src="${info.photo}" style="width:100%;max-height:700px;" />`,
        "图片查看",
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
        }
      ).catch((err) => err);
    },
    toImport () {
      this.$refs.uploadFile.click();
    },
    importFile (type) {
      this.type = type;
      this.fileInfo = null
      this.listInfo = null
      this.succNum = {}
      this.succStatus = false
      switch (type) {
        case "1":
          window.location.href = "/api/examinee/download/template";
          break;
        case "2":
          this.theTit = '导入考生信息'
          this.dialogVisible1 = true
          break;
        case "3":
          this.theTit = '导入考生照片'
          this.dialogVisible1 = true
          break;
        case "4":
          this.exportExaminee();
          break;
        default:
      }
    },
    //导出学生信息
    exportExaminee () {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post("/examinee/export", this.query, { responseType: "blob" })
        .then((res) => {
          exportFile(res);
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 文件选中上传
    uploadFileChange (e) {
      let file = e.target.files[0];
      let fileType = this.type === "2" ? ["xls"] : ["zip"];
      this.fileInfo = file
      if (this.verifyFileType(file, fileType, 50)) {
        let formData = new FormData();
        formData.append("file", file);
        let url =
          this.type === "2" ? "/examinee/import/1" : "/examinee/import/photo";
        this.submitFileInfo(url, formData);
      }
      //可清空当前file之前添加的文件
      e.outerHTML = e.outerHTML;
      e.target.value = "";
    },
    submitFileInfo (url, formData) {
      const loading = this.$loading({
        lock: true,
        text: "正在导入",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .post(url, formData)
        .then((res) => {
          console.log(88, res);
          if (this.type === "2") {
            if (res.data.code == 1234) {
              this.listInfo = res.data.msg.split(',')
              this.dialogVisible = true
            } else {
              this.sureImport()
              // this.listInfo = [0]
              // this.dialogVisible = true
            }
          } else if (this.type === "3") {
            let result = res.data.data;
            let message = `<strong>成功:${result.success}条,失败:${result.error}条.</strong>`;
            if (result.error > 0) {
              message += `导入失败的照片为: </br/><i style="color:red">`;
              result.errorList.forEach((e) => {
                message += `${e}</br/>`;
              });
              message += "</i>";
            }
            this.$alert(message, "导入照片提示", {
              dangerouslyUseHTMLString: true,
            });
          }
          loading.close();
          this.tableLoad();
        })
        .catch((err) => {
          loading.close();
          this.tableLoad();
        });
    },
    //校验文件格式
    verifyFileType (file, fileType, fileSize) {
      let type = file.name.split(".").slice(-1)[0].toLowerCase();
      if (!fileType.includes(type)) {
        this.$message({
          type: "error",
          message: `文件格式错误,请上传 ${fileType} 文件!`,
        });
        return false;
      }
      let isLt50M = file.size / 1024 / 1024 < fileSize;
      if (!isLt50M) {
        this.$message({
          type: "error",
          message: `文件大小超出限制,请上传小于 ${fileSize}M 的文件!`,
        });
        return false;
      }
      return true;
    },
    //提交学生信息
    submitStudentInfo () {
      if (this.saveAndUpdate) {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if (!this.student.photo) {
              this.$message.error("请上传考生照片！");
              return;
            }
            if (
              this.student.studentCity &&
              this.student.studentCity.length == 2
            ) {
              this.student.provinceId = this.student.studentCity[0];
              this.student.cityId = this.student.studentCity[1];
            }
            let obj = { ...this.student };
            if (!obj["mobileShow"]) obj.mobile = null;
            if (!obj["idNumberShow"]) obj.idNumber = null;
            this.addStudentLoading = true;
            const arr = ["mobileShow", "idNumberShow"];
            arr.forEach((item) => {
              Reflect.deleteProperty(obj, item);
            });
            this.$axios
              .post("/examinee/add", obj)
              .then((res) => {
                this.addStudentLoading = false;
                if (res.data.code == 10000) {
                  this.$message.success("添加成功！");
                  this.showAdd = false;
                  this.tableLoad();
                } else {
                  this.$message.error("添加失败！");
                }
              })
              .catch((err) => (this.addStudentLoading = false));
          } else {
            return false;
          }
        });
      } else {
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            if (!this.student.photo) {
              this.$message.error("请上传考生照片！");
              return;
            }
            if (
              this.student.studentCity &&
              this.student.studentCity.length == 2
            ) {
              this.student.provinceId = this.student.studentCity[0];
              this.student.cityId = this.student.studentCity[1];
            }
            let obj = { ...this.student };
            if (!obj["mobileShow"]) obj.mobile = null;
            if (!obj["idNumberShow"]) obj.idNumber = null;
            const arr = ["mobileShow", "idNumberShow"];
            arr.forEach((item) => {
              Reflect.deleteProperty(obj, item);
            });
            this.$axios
              .post("/examinee/update", obj)
              .then((res) => {
                this.addStudentLoading = false;
                if (res.data.code == 10000) {
                  this.$message.success("修改成功！");
                  this.showAdd = false;
                  this.tableLoad();
                } else {
                  this.$message.error("修改失败！");
                }
              })
              .catch((err) => (this.addStudentLoading = false));
          } else {
            return false;
          }
        });
      }
    },
    //国籍下拉框
    getCountryList () {
      this.$axios.get("register").then((res) => {
        this.countryList = res.data.data;
      });
    },
    handleAvatarSuccess (res) {
      if (res.code == 10000) {
        this.$set(this.student, "photo", res.data.url);
      } else {
        this.$message.error("照片上传失败！");
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传照片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传照片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    },
    //添加考生
    // addStudent() {
    //   this.student = {
    //     sex: 1,
    //   };
    //   this.showAdd = true;
    // },

    //导出excel
    exportExcel () {
      this.$axios
        .post("/examinee/export", this.query, { responseType: "blob" })
        .then((res) => {
          exportFile(res);
        });
    },
    tableLoad () {
      this.$axios.post("/examinee", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    getAllUser () {
      this.$axios.get("/examinee").then((res) => {
        let data = res.data.data;
        this.examineeList = data.map((item) => {
          let children = item.cityVOS.map((tree) => {
            return {
              value: tree.cityId,
              label: tree.cityName,
            };
          });
          return {
            value: item.provinceId,
            label: item.provinceName,
            children,
          };
        });
      });
    },
    handleChange () {
      this.query.provinceId = this.cityIds[0] ? this.cityIds[0] : "";
      this.query.cityId = this.cityIds[1] ? this.cityIds[1] : "";
      this.tableLoad();
    },
    clearFrom () {
      this.student = {
        birthDay: "",
        cityId: "",
        countryId: "",
        englishName: "",
        expressAddress: "",
        idNumber: "",
        mobile: "",
        name: "",
        photo: "",
        provinceId: "",
        sex: 1,
        surName: "",
      };
    },
    operatInfo (type, row) {
      if (type === 1) {
        this.showAdd = true;
        this.student["idNumberShow"] = true;
        this.student["mobileShow"] = true;
        this.saveAndUpdate = true;
        this.title = "添加考生";
      } else if (type == 2) {
        this.title = "修改考生";
        this.saveAndUpdate = false;
        // 修改
        this.student = JSON.parse(JSON.stringify(row));
        this.student["idNumberShow"] =
          this.student["idNumber"].indexOf("*") === -1;
        this.student["mobileShow"] = this.student["mobile"].indexOf("*") === -1;
        this.student.birthDay = this.$tagTime(
          this.student.birthDay,
          "yyyy-MM-dd"
        );
        this.student.studentCity = [
          this.student.provinceId * 1,
          this.student.cityId * 1,
        ];
        this.showAdd = true;
      } else if (type == 3) {
        this.$dailog({
          title: "提示",
          context: "确认将密码修改为当前联系电话？",
          callbackFun: () => {
            this.$axios
              .post("user/init", {
                mobile: row.mobile,
                userId: row.userId,
              })
              .then((res) => {
                this.$message({
                  type: "success",
                  message: "初始化成功!", duration: 1000
                });
                this.tableLoad();
              });
          },
        });
      } else if (type == 0) {
        // 删除
        let context =
          row.link == 0
            ? "确定删除该考生信息？"
            : "该考生已报名，删除后该考生注册、报名、考试信息将无法恢复，是否继续删除？";
        this.$dailog({
          title: "删除",
          context,
          callbackFun: () => {
            this.$axios
              .delete("examinee/delete", {
                data: [row.userId],
              })
              .then((res) => {
                this.$message.success({
                  message: "删除成功！",
                  duration: 1000,
                });
                this.tableLoad();
              });
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.studentinfo {
  .el-cascader {
    line-height: 35px;
  }

  ::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 176px;
    height: 225px;
    display: block;
  }
}
</style>
